import { createSelector } from '@reduxjs/toolkit';

const SLICE_KEYS = [
  'currentJob',
  'hiringTeam',
  'updatedHiringTeam',
  'getOffices',
  'getJobPost',
  'defaultJobPost',
  'formTemplateOptions',
  'getInterviewPlan',
  'getInterviewPools',
  'getHackerrankStatus',
];

// Memoised: built inline it returned a fresh object on every call, so react-redux
// saw a new reference on every dispatch anywhere in the app and re-rendered all
// ~90 consumers — including every kanban card.
export const getAtsJobCreate = createSelector(
  SLICE_KEYS.map((key) => (state) => state?.atsJobCreate?.[key]),
  (...values) =>
    SLICE_KEYS.reduce((acc, key, index) => {
      acc[key] = values[index];
      return acc;
    }, {})
);

// Single-slice selectors for hot paths. These need no memoisation — they hand
// back the reducer's own reference, so they only change when that slice does.
// Prefer them over the wide selector: a component reading currentJob shouldn't
// re-render when the interview plan or Hackerrank status loads.
export const getAtsCurrentJob = (state) => state?.atsJobCreate?.currentJob;
export const getAtsInterviewPlan = (state) =>
  state?.atsJobCreate?.getInterviewPlan;
